// src/pages/public/Support.jsx
// FASE 2.C — P-05 Soporte / FAQ (pixel-perfect del mockup v4 + 2 cambios autorizados).
// Source: entregable_claude/screens_public.jsx líneas 124-181.
// Cambios respecto al mockup:
//   1. Sección de contacto: 1 sola card Email centrada banner horizontal (mockup tenía
//      grid 2 cols WhatsApp + Email; eliminamos WhatsApp).
//   2. Email cambiado a contacto@edgeelite.cl.
//   3. FAQ #4 actualizada con casas: Coolbet, EpicBet, Bet365, 1xbet.
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { PubHead } from './_publicShared';
import { useSmartBack } from '../../auth/useSmartBack';

const FAQS = [
  {
    q: '¿Cómo funciona Edge Elite?',
    a: 'Analizamos partidos de básquet en vivo con un modelo estadístico. Cuando detectamos que la línea de la casa está mal calibrada (existe ventaja matemática), te enviamos una alerta por Telegram con la apuesta sugerida.',
  },
  {
    q: '¿Garantizan que voy a ganar?',
    a: 'No. Apostar siempre conlleva riesgo. Lo que ofrecemos es ventaja estadística a largo plazo: en muestra grande de picks, el ROI tiende a ser positivo. Pero en el corto plazo puede haber pérdidas.',
  },
  {
    q: '¿Es una suscripción?',
    a: 'Sí. Es un plan mensual de $19.990 que se renueva automáticamente. Al activarla tienes 5 días de prueba gratis, y puedes cancelar cuando quieras desde Mi cuenta: dejas de pagar y conservas el acceso hasta el final del período ya pagado.',
  },
  {
    q: '¿Qué casas de apuestas usan?',
    a: 'Trabajamos principalmente con Betano, pero las cuotas también suelen estar disponibles en Coolbet, EpicBet, Bet365, 1xbet y otras casas reguladas.',
  },
  {
    q: '¿Cómo cancelo mi cuenta?',
    a: 'Desde Mi cuenta → Configuración → Eliminar cuenta. La cancelación es inmediata y se borran todos tus datos.',
  },
  {
    q: '¿Cuánto tarda en activarse mi pago?',
    a: 'Normalmente entre 1 y 5 minutos. Si pasaron más de 10 minutos sin activación, contáctanos.',
  },
];

export default function Support() {
  const [open, setOpen] = useState(0);

  // FIX back-button: useSmartBack respeta history primero, y si entró
  // directo por URL cae al destino correcto según rol/acceso.
  const handleBack = useSmartBack();

  return (
    <div className="mobile-root">
      <Helmet>
        <title>Soporte y preguntas frecuentes · Edge Elite</title>
        <meta name="description" content="Resuelve dudas sobre Edge Elite: cómo funciona el motor, planes, prueba gratis de 5 días, casas compatibles y contacto." />
        <link rel="canonical" href="https://edgeelite.cl/soporte" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Soporte y preguntas frecuentes · Edge Elite" />
        <meta property="og:url" content="https://edgeelite.cl/soporte" />
      </Helmet>

      <section className="screen" style={{ paddingTop: 28, paddingBottom: 60 }}>
        <PubHead back={handleBack} title="Soporte" />

        <div className="screen-head">
          <h2>¿En qué te ayudamos?</h2>
          <p>Encuentra respuestas rápidas o escríbenos directo.</p>
        </div>

        {/* Card Email banner (1 sola, centrada) */}
        <div style={{ marginBottom: 28 }}>
          <a
            href="mailto:contacto@edgeelite.cl"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 16,
              padding: '20px 24px',
              background: 'var(--bg-elev)',
              border: '1px solid var(--line)',
              borderRadius: 14,
              cursor: 'pointer',
              textDecoration: 'none',
              color: 'inherit',
              maxWidth: 480,
              margin: '0 auto',
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 999,
                background: 'var(--accent-soft)',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 'none',
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="var(--accent)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="5" width="18" height="14" rx="2" />
                <path d="m3 7 9 6 9-6" />
              </svg>
            </div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 2 }}>Escríbenos por email</div>
              <div style={{ fontSize: 13, color: 'var(--accent)', fontWeight: 500 }}>
                contacto@edgeelite.cl
              </div>
            </div>
          </a>
        </div>

        {/* FAQ accordion */}
        <div className="eyebrow" style={{ marginBottom: 12 }}>
          Preguntas frecuentes
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {FAQS.map((f, i) => (
            <div
              key={i}
              style={{
                background: 'var(--bg-elev)',
                border: '1px solid var(--line)',
                borderRadius: 12,
                overflow: 'hidden',
              }}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                style={{
                  width: '100%',
                  padding: 16,
                  background: 'transparent',
                  border: 0,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                <span style={{ fontSize: 14, fontWeight: 600, paddingRight: 12 }}>{f.q}</span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--muted)"
                  strokeWidth="2.4"
                  style={{
                    transform: open === i ? 'rotate(180deg)' : 'rotate(0)',
                    transition: 'transform .2s',
                    flex: 'none',
                  }}
                >
                  <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              {open === i && (
                <div
                  style={{
                    padding: '14px 16px 16px',
                    fontSize: 13,
                    color: 'var(--muted)',
                    lineHeight: 1.55,
                    borderTop: '1px solid var(--line)',
                  }}
                >
                  {f.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
